module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/2-3-606c6f9338950d3c19c54a9da62f30b2.png";